import { Item } from 'back_office/v2/redux/models/models'
export default Item.actions
